import React from 'react'
import { Card, CardDescription, CardHeader, CardTitle } from '../ui/card'
import { Palette, Type, Image, Layers } from 'lucide-react'

interface VisualIdentityTabProps {
  onToolboxItemSelect: (itemId: string) => void
}

export function VisualIdentityTab({ onToolboxItemSelect }: VisualIdentityTabProps) {
  const handleItemClick = (itemId: string) => {
    onToolboxItemSelect(itemId)
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Visual Identity</h2>
        <p className="text-slate-600">Define your brand's visual elements including colors, typography, and imagery</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card 
          className="cursor-pointer hover:shadow-lg transition-shadow" 
          onClick={() => handleItemClick('color-palette')}
        >
          <CardHeader className="p-[21px]">
            <CardTitle className="flex items-center gap-3">
              <Palette className="w-6 h-6 text-blue-500" />
              Color Palette
            </CardTitle>
            <CardDescription>
              Define your brand colors and usage guidelines
            </CardDescription>
          </CardHeader>
        </Card>
        
        <Card 
          className="cursor-pointer hover:shadow-lg transition-shadow" 
          onClick={() => handleItemClick('typography')}
        >
          <CardHeader>
            <CardTitle className="flex items-center gap-3">
              <Type className="w-6 h-6 text-green-500" />
              Typography System
            </CardTitle>
            <CardDescription>
              Choose fonts and establish typographic hierarchy
            </CardDescription>
          </CardHeader>
        </Card>
        
        <Card 
          className="cursor-pointer hover:shadow-lg transition-shadow" 
          onClick={() => handleItemClick('logo-guidelines')}
        >
          <CardHeader className="p-[21px]">
            <CardTitle className="flex items-center gap-3">
              <Image className="w-6 h-6 text-purple-500" />
              Logo Guidelines
            </CardTitle>
            <CardDescription>
              Define logo usage, spacing, and applications
            </CardDescription>
          </CardHeader>
        </Card>
        
        <Card 
          className="cursor-pointer hover:shadow-lg transition-shadow" 
          onClick={() => handleItemClick('mood-board')}
        >
          <CardHeader>
            <CardTitle className="flex items-center gap-3">
              <Layers className="w-6 h-6 text-orange-500" />
              Mood Board
            </CardTitle>
            <CardDescription>
              Collect visual inspiration and aesthetic direction
            </CardDescription>
          </CardHeader>
        </Card>
      </div>
    </div>
  )
}